import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import GenericTableComponent from "../common/Table";
import { getTopCampaigns } from "../../redux/slices/campaignSlice";

const columns = [
  { id: "campaignname", label: "Name" },
  { id: "campaignreference", label: "Reference" },
  { id: "campaignobjective", label: "Type" },
  { id: "campaignbudget", label: "Budget" },
  { id: 'totalconversion', label: 'Conversions' },
  { id: 'reach', label: 'Clicks' },
  { id: "conversionRate", label: "CR" },
  { id: 'costperuser', label: 'CPA' },
  { id: 'amountspent', label: 'Amount Spent' },
  { id: "eCPM", label: "eCPM" },
  //{ id: "isapproved", label: "Approval" },
  //{ id: "flow", label: "Flow" },
];

const CpcTable = () => {
  const dispatch = useDispatch();
  const { topCampaigns, loading } = useSelector((state) => state.campaign);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const obj = 'CPC'
  useEffect(() => {
    dispatch(getTopCampaigns({ page, rowsPerPage, campaignObj: obj }));
  }, [dispatch, page, rowsPerPage]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const filteredCampaigns = topCampaigns.slice(0, 5);

  return (
    <div style={{ padding: "0" }}>
      {loading ? (
        <div>Loading...</div>
      ) : filteredCampaigns.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          No CPA campaigns available.
        </div>
      ) : (
        <GenericTableComponent
          columns={columns}
          data={filteredCampaigns}
          viewLink="/view-campaign"
          editLink="/edit-campaign"
          page={page}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
          totalItems={filteredCampaigns.length}
        />
      )}
    </div>
  );
};

export default CpcTable;
